/* eslint-disable eag/match-named-export, eag/no-index -- Pre-existing grab-bag file with several exports. Pre-existing violation */
import {toPairs} from 'ramda';

import {
  TaxDocumentCalculationSummaryItemResponseBody,
  VatTypeSummaryV2ResponseBody,
} from '@dms/api/shared';

export type SummaryItemType = TaxDocumentCalculationSummaryItemResponseBody & {
  summaryType: 'calculation' | 'exchangeRateRatioCalculation';
};

export const typedToPairs = (val: Record<string, VatTypeSummaryV2ResponseBody>) => toPairs(val);
